export  function postSlider() {
    $(".post-slider").each(function () {
        let curSliderWrap = $(this);
        let curSlider = curSliderWrap.find(".swiper-container");
		
        let swiperOptions = {
            watchOverflow: true,
            spaceBetween: 10,
            slidesPerView: 1,
            navigation: {
                nextEl: `.${curSliderWrap.find(".swiper-button-next").attr("class")}`,
                prevEl: `.${curSliderWrap.find(".swiper-button-prev").attr("class")}`,
            },
            breakpoints: {
                568: {
                    slidesPerView: 2.3,
                },
                1024: {
                    slidesPerView: 2.3,
                    spaceBetween: 16,
                },
                1200: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
            }
        };

        let swiper = new Swiper(`.${curSlider.attr("class")}`, swiperOptions);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/postSlider.js